class PdpCata extends HTMLElement {
  constructor() {
    super();
    this.pinnedIdx = null;
    this.hoverIdx = null;
    try {
      const data = this.querySelector("[data-attrs-json]");
      this.attrs = data ? JSON.parse(data.textContent) : [];
    } catch (e) {
      this.attrs = [];
    }
    this.init();
  }

  get activeIdx() {
    return this.hoverIdx !== null ? this.hoverIdx : this.pinnedIdx;
  }

  init() {
    this.rows = Array.from(this.querySelectorAll("[data-attr-row]"));
    this.dots = Array.from(this.querySelectorAll("[data-attr-dot]"));
    this.labels = Array.from(this.querySelectorAll("[data-attr-label]"));
    this.axes = Array.from(this.querySelectorAll("[data-attr-axis]"));
    this.infoEmpty = this.querySelector("[data-info-empty]");
    this.infoActive = this.querySelector("[data-info-active]");
    this.infoName = this.querySelector("[data-info-name]");
    this.infoNum = this.querySelector("[data-info-num]");
    this.infoDesc = this.querySelector("[data-info-desc]");

    [...this.rows, ...this.labels, ...this.dots].forEach((el) => {
      const idx = parseInt(
        el.dataset.attrRow || el.dataset.attrLabel || el.dataset.attrDot,
        10
      );
      el.addEventListener("mouseenter", () => {
        this.hoverIdx = idx;
        this.applyActive();
      });
      el.addEventListener("mouseleave", () => {
        this.hoverIdx = null;
        this.applyActive();
      });
      el.addEventListener("click", (e) => {
        e.preventDefault();
        this.hoverIdx = null;
        this.pinnedIdx = this.pinnedIdx === idx ? null : idx;
        this.applyActive();
      });
      if (el.tagName === "BUTTON" || el.tagName === "G") {
        el.addEventListener("focusin", () => {
          this.hoverIdx = idx;
          this.applyActive();
        });
        el.addEventListener("focusout", () => {
          this.hoverIdx = null;
          this.applyActive();
        });
      }
    });
    this.applyActive();
  }

  applyActive() {
    const idx = this.activeIdx;
    this.rows.forEach((el) =>
      el.classList.toggle(
        "is-active",
        parseInt(el.dataset.attrRow, 10) === idx
      )
    );
    this.labels.forEach((el) =>
      el.classList.toggle(
        "is-active",
        parseInt(el.dataset.attrLabel, 10) === idx
      )
    );
    this.dots.forEach((el) =>
      el.classList.toggle(
        "is-active",
        parseInt(el.dataset.attrDot, 10) === idx
      )
    );
    this.axes.forEach((el) =>
      el.classList.toggle(
        "is-active",
        parseInt(el.dataset.attrAxis, 10) === idx
      )
    );

    if (idx === null || idx === undefined || !this.attrs[idx]) {
      if (this.infoEmpty) this.infoEmpty.style.display = "";
      if (this.infoActive) this.infoActive.style.display = "none";
      return;
    }
    const a = this.attrs[idx];
    if (this.infoEmpty) this.infoEmpty.style.display = "none";
    if (this.infoActive) this.infoActive.style.display = "";
    if (this.infoName) this.infoName.textContent = a.k;
    if (this.infoNum)
      this.infoNum.innerHTML =
        a.v.toFixed(2).replace(".", ",") + "<small>/10</small>";
    if (this.infoDesc) this.infoDesc.textContent = a.d;
  }
}

if (!customElements.get("pdp-cata")) {
  customElements.define("pdp-cata", PdpCata);
}
